module.exports = __webpack_public_path__ + "static/media/instagram.03f40b67.png";